'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dividerStyles = {
  "dividerBlock": "draftJsDividerPlugin__dividerBlock__4VxnL"
};

var _dividerStyles2 = _interopRequireDefault(_dividerStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Divider = function Divider() {
  return _react2.default.createElement('hr', { className: _dividerStyles2.default.dividerBlock });
};

exports.default = Divider;